export interface Map<T> {
    [key: string]: T;
}

export interface MapKeyNumber<T> {
    [key: number]: T;
}